import ShareLinks from '@commons/components/ShareLinks';
import type { ShareLinkType } from '@commons/components/ShareLinks';
import PageBuilder from '@commons/pagebuilder';
import type { DrupalBlock } from '@commons/types/drupal';

// Type definition for the ShareLinksBlock component properties.

type Props = DrupalBlock<{
  links: ShareLinkType[];
  emailSubject?: string;
  emailBody?: string;
}>;

/**
 * ShareLinksBlock component.
 */

const ShareLinksBlock = ({ content }: Props) => {
  const { links } = content;

  const page = PageBuilder.getPage();

  const emailSubject = content.emailSubject || page?.metaTags.title;
  const emailBody = content.emailBody || page?.metaTags?.description;

  return <ShareLinks links={links} emailSubject={emailSubject} emailBody={emailBody} />;
};

export default ShareLinksBlock;
